import { render, staticRenderFns } from "./ChannelsView.vue?vue&type=template&id=609bc3ee"
import script from "./ChannelsView.vue?vue&type=script&lang=js"
export * from "./ChannelsView.vue?vue&type=script&lang=js"
import style0 from "./ChannelsView.vue?vue&type=style&index=0&id=609bc3ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports